import Button from './Button';

export const EmptyState = ({
  title,
  description,
  icon,
  actionLabel,
  onAction,
  className = ''
}) => {
  return (
    <div className={`text-center py-20 ${className}`}>
      {icon ? (
        <div className="inline-flex items-center justify-center w-20 h-20 bg-gray-100 dark:bg-slate-800 rounded-full mb-4">
          {icon}
        </div>
      ) : null}
      {title && <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">{title}</h3>}
      {description && <p className="text-gray-600 dark:text-gray-400 mb-6">{description}</p>}
      {onAction && actionLabel ? (
        <div className="flex justify-center">
          <Button variant="outline" onClick={onAction}>
            {actionLabel}
          </Button>
        </div>
      ) : null}
    </div>
  );
};

